import eventWidgetExtraProperties from '../lib/event-widget-extra-properties'

const createQuery = () => `
  ... on EventFormWidget {
    ${eventWidgetExtraProperties}
    id
    type
    formBuilder {
      _id
      title
      questions {
        question
        width
        required
      }
      thankyouMessage
    }
  }
`

export default createQuery
